export enum IntentTypes {
  register = "register",
  new = "new",
  updateMobilePepclub = "pepclub",
  partial = "partial",
  login = "login",
  empty = "",
}

export enum MetacomStatusType {
  loginOpen = "login-open",
  loginWalled = "login-walled",
  InsufficientData = "insufficientData",
}
